import axios from 'axios';

function logError(data) {
  axios.post(
    'https://hook.eu1.make.com/iu3kffkn9aqck4jdrbvyhahtaqr6a55k',
    data
  );
}

// eslint-disable-next-line comma-dangle
export { logError };
